import React, { useEffect } from "react";
import { Link } from "react-scroll";
import AOS from "aos";

function Hero() {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: "ease-in-out",
      once: true,
    });
  }, []);

  return (
    <div className="container-fluid h-100 d-flex align-items-center justify-content-center hero-content px-0">
      <div className="row w-100">
        {/* Text Section */}
        <div
          className="col-md-6 d-flex flex-column justify-content-center order-2 order-md-1 hero-start"
          data-aos="fade-right"
        >
          <h1 className="hero-h1">
            Hi, I’m <span className="text-grey">Chinaza, a UX Designer.</span>
          </h1>
          <p className="hero-p pt-3">
            I’m passionate about designing human-centered, interactive, and
            culturally inclusive designs.
          </p>
          <div className="d-flex py-3 gap-4">
            <Link
              className="nav-link text-dark"
              to="work"
              smooth={true}
              duration={500}
              activeClass="active-link"
              spy={true}
              style={{ width: "100%" }}
            >
              <button
                type="button"
                className="border-0 text-white button-filled"
              >
                View Work
              </button>
            </Link>
            <a
              href="https://storage.googleapis.com/uxfolio/64793b4efb157900025506db/Chinaza_Eskay__2__9Vb.pdf"
              target="_blank"
              rel="noopener noreferrer"
              style={{ width: "100%" }}
            >
              <button type="button" className="bg-white button-outline">
                Download CV
              </button>
            </a>
          </div>
        </div>

        {/* Image Section */}
        <div
          className="col-md-6 d-flex justify-content-center align-items-center order-1 order-md-2 p-0"
          data-aos="fade-left"
        >
          <img
            src="/image/hero.png"
            alt="Chinaza"
            className="img-fluid hero-image"
          />
        </div>
      </div>
    </div>
  );
}

export default Hero;
